import React, {useState, useCallback} from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import Event from '../Inputs/Event';
import useStyles from './styles';

const NewEvent = ({onSubmit, onClose}) => {

  const classes = useStyles();

  const [eventData, setEventData] = useState('');
  const onEventChange = useCallback(event => {
    event.persist && event.persist();
    setEventData(event.target.value);
  }, [setEventData]);

  const _onSubmit = event => {
    event.preventDefault();
    onSubmit(eventData);
  };

  return <form onSubmit={_onSubmit}>
    <Grid container justify='space-around'>
      <Grid item xs={12}>
        <Typography className={classes.text}>
          Novo Evento
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Event
          required
          fullWidth
          value={eventData}
          onChange={onEventChange}
        />
      </Grid>
      <Grid item>
        <Button color="primary" type='submit'>
          Salvar
        </Button>
      </Grid>
      <Grid item>
        <Button color="secondary" onClick={onClose}>
          Fechar
        </Button>
      </Grid>
    </Grid>
  </form>;
};

export default NewEvent;
